import * as React from "react";
import { Upload, message, Button } from "antd";
import { CustomModal } from "../common/CustomModal";
import styled from "styled-components";
import {
  COURSE_TOPIC_QUESTION_AUDIO_UPLOAD_PATH,
  COURSE_TOPIC_QUESTION_VIDEO_UPLOAD_PATH,
} from "../../constant/comman";

const Dragger = Upload.Dragger;

const StyledDragger = styled(Dragger)`
  & .ant-upload {
    margin-bottom: 15px;
  }

  & .ant-upload-drag {
    margin-bottom: 15px;
  }
  & .ant-upload-list-item-actions {
    display: none;
  }
`;

const videoProps = {
  name: "video",
  action: COURSE_TOPIC_QUESTION_VIDEO_UPLOAD_PATH,
  headers: {
    authorization: "authorization-text",
  },
};

const audioProps = {
  name: "audio",
  action: COURSE_TOPIC_QUESTION_AUDIO_UPLOAD_PATH,
  headers: {
    authorization: "authorization-text",
  },
};

var temp = [];

export class AddQuestionMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disable: true,
      jsonFile: [],
      disableUpload: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.verifyDoc = this.verifyDoc.bind(this);
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  verifyDoc() {
    if (temp.length <= 0) {
      message.error("Please select a valid file");
      return;
    }

    this.props.onUpload(temp[0].response.file);
  }

  handleChange(info) {
    if (info.file.status !== "uploading") {
      if (info.fileList.length < 1) {
        this.setState({
          disable: true,
        });
      } else {
        this.setState({
          disable: false,
        });
      }
    }

    if (info.file.status === "done") {
      if (info.file.response.code === "ERROR_IN_UPLOAD") {
        message.error(info.file.response.msg);
      } else {
        message.success(`${info.file.name} file uploaded successfully.`);
        temp = info.fileList;
      }
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  }

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState(
      {
        visible: false,
      },
      () => {}
    );
  }

  render() {
    const { selectedMediaType } = this.props;
    const isVideo = selectedMediaType === "video";

    return (
      <CustomModal
        width="600px"
        title={isVideo ? "Upload Question Video" : "Upload Question Audio"}
        visible={this.state.visible}
        onClose={this.handleCancel.bind(this)}
        maskClosable={false}
      >
        <div className="premium-upload-container">
          {isVideo ? (
            <StyledDragger
              accept=".mpg,.mp2,.mpeg,.mpe,.mpv,.mp4,.m4p,.m4v,.mkv,.flv,.vob,.svi,.ogg,.ogv,.mov"
              className="premium-upload-dragger"
              {...videoProps}
              onChange={this.handleChange}
              onRemove={(file) => console.log("Removed -- ", file)}
            >
              <div className="premium-upload-icon-wrapper">
                <svg viewBox="0 0 24 24">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
                </svg>
              </div>
              <p className="premium-upload-text">
                Click or drag video to this area
              </p>
              <p className="premium-upload-hint">
                Supports single video upload (.mp4, .mov, .webm)
              </p>
            </StyledDragger>
          ) : (
            <StyledDragger
              accept=".mp3,.acc,.ogg,.m4a"
              className="premium-upload-dragger"
              {...audioProps}
              onChange={this.handleChange}
              onRemove={(file) => console.log("Removed -- ", file)}
            >
              <div className="premium-upload-icon-wrapper">
                <svg viewBox="0 0 24 24">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
                </svg>
              </div>
              <p className="premium-upload-text">
                Click or drag audio to this area
              </p>
              <p className="premium-upload-hint">
                Supports single audio upload (.mp3, .m4a, .ogg)
              </p>
            </StyledDragger>
          )}

          <div className="premium-upload-actions">
            <Button
              className="premium-cancel-btn"
              onClick={this.handleCancel.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="premium-upload-btn"
              disabled={this.state.disable}
              onClick={this.verifyDoc}
            >
              Upload
            </Button>
          </div>
        </div>
      </CustomModal>
    );
  }
}
